(() => {
 function initialize(root) {
 if (root.dataset.initialized) return;
 const guideModels = JSON.parse(root.querySelector('[data-guide-data]').textContent);
 const baseGuides = JSON.parse(root.querySelector('[data-base-guide-data]')?.textContent || '{}');
 const copy = JSON.parse(root.querySelector('[data-guide-copy]').textContent);
 const text = (key, values = {}) => copy[key].replace(/__LSI_(\w+)__/g, (_, name) => values[name] ?? '');
 const get = id => root.querySelector('#lsi-' + id);
  'use strict';
  const finder = get('guide-finder');
  if (!finder || typeof guideModels === 'undefined') return;

  const versionField = get('version-fieldset');
  const versionOptions = get('version-options');
  const sizeField = get('size-fieldset');
  const sizeOptions = get('size-options');
  const result = get('guide-result');
  const eyebrow = get('result-eyebrow');
  const title = get('result-title');
  const description = get('result-description');
  const download = get('guide-download');
  const baseGuide = get('base-guide');
  const baseDownload = get('base-download');
  const baseDescription = get('base-description');
  let modelKey = 'aura';
  let versionKey = 'standard';
  let size = '';

  const sizeLabel = value => value.replace('x', ' × ') + ' ' + copy.unit;
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

  function choice(name, value, labelText, detail) {
    const label = document.createElement('label');
    label.className = 'lsi-choice';
    const input = document.createElement('input');
    input.type = 'radio';
    input.name = name;
    input.value = value;
    input.checked = value === (name === 'lsi-version' ? versionKey : size);
    const content = document.createElement('span');
    if (detail) {
      const heading = document.createElement('strong');
      heading.textContent = labelText;
      const subtitle = document.createElement('small');
      subtitle.textContent = detail;
      content.append(heading, subtitle);
    } else content.textContent = labelText;
    label.append(input, content);
    return label;
  }

  function renderFields() {
    const model = guideModels[modelKey];
    root.querySelectorAll('input[name="lsi-model"]').forEach(input => { input.checked = input.value === modelKey; });
    versionField.hidden = Object.keys(model.versions).length === 1;
    versionOptions.replaceChildren();
    if (!versionField.hidden) {
      Object.entries(model.versions).forEach(([key, value]) => {
        versionOptions.append(choice('lsi-version', key, value.label, value.description));
      });
    }
    renderSizes();
  }

  function renderSizes() {
    sizeOptions.replaceChildren();
    const version = guideModels[modelKey].versions[versionKey];
    sizeField.hidden = !version;
    if (version) version.sizes.forEach(value => sizeOptions.append(choice('lsi-size', value, sizeLabel(value))));
    renderResult();
  }

  function renderResult() {
    const model = guideModels[modelKey];
    const version = model.versions[versionKey];
    if (baseGuide && baseDownload) {
      const baseUrl = version && size && versionKey !== 'previous' ? baseGuides[modelKey]?.[size] : '';
      baseGuide.hidden = !baseUrl;
      baseDownload.removeAttribute('href');
      baseDownload.removeAttribute('aria-label');
      baseDescription.textContent = '';
      if (baseUrl) {
        baseDescription.textContent = `${model.name} · ${sizeLabel(size)}`;
        baseDownload.href = baseUrl;
        baseDownload.setAttribute('aria-label', text('base_open_label', {model:model.name,size:sizeLabel(size)}));
      }
    }
    download.hidden = true;
    download.removeAttribute('href');
    download.removeAttribute('aria-label');
    result.dataset.state = 'pending';
    eyebrow.textContent = copy.instructions;
    if (!version) {
      title.textContent = copy.choose_version;
      description.textContent = copy.version_help;
    } else if (!size) {
      title.textContent = text('choose_size', {model:model.name});
      description.textContent = copy.pending;
    } else if (!(version.customGuides?.[size] || (version.available.includes(size) && version.url))) {
      result.dataset.state = 'unavailable';
      eyebrow.textContent = copy.missing_label;
      title.textContent = `${model.name} · ${sizeLabel(size)}`;
      description.textContent = copy.missing_description;
      download.textContent = copy.request;
      download.href = 'mailto:support@luxsol.co.uk?subject=' + encodeURIComponent(text('request_subject', {model:model.name,size:sizeLabel(size)})) + '&body=' + encodeURIComponent(text('request_body', {model:model.name,size:sizeLabel(size)}));
      download.removeAttribute('target');
      download.hidden = false;
    } else {
      const customUrl = version.customGuides?.[size];
      result.dataset.state = 'ready';
      eyebrow.textContent = customUrl ? copy.instructions : text('metadata', {pages:version.pages,file_size:version.fileSize});
      title.textContent = `${model.name} · ${sizeLabel(size)}`;
      const coverage = version.available.map(sizeLabel).join(copy.and);
      description.textContent = modelKey === 'tora' ? text('current_coverage', {version:version.label}) : text('coverage', {sizes:coverage});
      download.textContent = copy.open;
      download.href = customUrl || version.url;
      download.target = '_blank';
      download.setAttribute('aria-label', text('open_label', {model:model.name,size:sizeLabel(size)}));
      download.hidden = false;
    }
  }

  function saveSelection() {
    const url = new URL(window.location.href);
    url.searchParams.set('model', modelKey);
    if (versionKey && versionKey !== 'standard') url.searchParams.set('version', versionKey);
    else url.searchParams.delete('version');
    if (size) url.searchParams.set('size', size);
    else url.searchParams.delete('size');
    window.history.replaceState(null, '', url);
  }

  function restoreSelection() {
    const params = new URLSearchParams(window.location.search);
    const requestedModel = params.get('model');
    modelKey = requestedModel && own(guideModels, requestedModel) ? requestedModel : 'aura';
    const versions = guideModels[modelKey].versions;
    const requestedVersion = params.get('version');
    versionKey = Object.keys(versions).length === 1 ? Object.keys(versions)[0] : (requestedVersion && own(versions, requestedVersion) ? requestedVersion : '');
    const version = versions[versionKey];
    const requestedSize = params.get('size');
    size = version && version.sizes.includes(requestedSize) ? requestedSize : '';
    renderFields();
  }

  finder.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    if (input.name === 'lsi-model' && own(guideModels, input.value)) {
      modelKey = input.value;
      const versions = Object.keys(guideModels[modelKey].versions);
      versionKey = versions.length === 1 ? versions[0] : '';
      size = '';
      renderFields();
    } else if (input.name === 'lsi-version' && own(guideModels[modelKey].versions, input.value)) {
      versionKey = input.value;
      size = '';
      renderSizes();
    } else if (input.name === 'lsi-size' && guideModels[modelKey].versions[versionKey]?.sizes.includes(input.value)) {
      size = input.value;
      renderResult();
    } else return;
    saveSelection();
  });
  window.addEventListener('popstate', restoreSelection);
  restoreSelection();
  finder.hidden = false;
  root.querySelector('[data-guide-fallback]').hidden = true;
  root.dataset.initialized = 'true';
 }
 document.querySelectorAll('[data-luxsol-self-installation]').forEach(initialize);
 document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-luxsol-self-installation]').forEach(initialize));
})();
